// Module
var code = "<div id=\"V-6FBE1072-3F37-4A39-9FF1-9C2E0B6C1E45\"> <h6>ایجاد جدید</h6> </div> ";
// Exports
export default code;